<div *ngIf='form as form' [formGroup]='form'>
  <fieldset>
    <legend>Dane podstawowe</legend>
    <div class="row">
      <div class='col-md-6'>
        <div class='form-group' *ngIf='"deviceType" as controlName'>
          <label [for]='controlName'>
            Rodzaj urządzenia *
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu rodzaj urządzenia'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <fieldset>
      <legend>
        Decyzje
      </legend>
      <app-location-decisions-crud [formControl]="form.locationDecisions">
      </app-location-decisions-crud>
    </fieldset>
  </fieldset>
  <br>
  <fieldset>
    <legend>
      Etapy
    </legend>
    <app-tab-view
      [simple]='false'
      (onAddNew)='form.addStage()'
      addBtnTitle='Dodaj kolejny etap'
      [showAddButton]='true'
      [centered]='true'
      formArrayName='stages'>
      <ng-container *ngFor='let stageForm of form.getStageForms(); let i = index;'>
        <app-tab-panel
          (onClose)='form.removeStage(i)'
          [closeBtnDisabled]='i === 0'
          [showCloseBtn]='true'
          [name]='"Etap nr " + (i + 1)' [selected]='i === (form.stages.controls.length - 1)'>
          <app-location-of-devices-unrelated-to-road-occupation-stage-form
            [formGroup]="form"
            [serviceId]="serviceId()"
            [label]='"Etap nr " + (i + 1)'
            [canRemoveStage]='i !== 0'
            [form]='stageForm'>
          </app-location-of-devices-unrelated-to-road-occupation-stage-form>
        </app-tab-panel>
      </ng-container>
    </app-tab-view>
  </fieldset>
</div>
